import React from "react";

import { About, Header, Skills, Footer, Work } from "./container";
import { Navbar } from "./components";
import "./App.scss";
import Copyright from "./container/Copyright/Copyright";

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Footer />
      <Copyright/>
    </div>
  );
};

export default App;
